export default {
      id: "ic_etoile_vide-usage",
      viewBox: "0 0 15 15",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic_etoile_vide-usage",
      toString: function () {
        return this.url;
      }
    }